export default "__VITE_ASSET__Dguv9l7F__"